import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.832 11.025H19v1.944H8.825l4.793 4.657L12.204 19 5 12l7.204-7 1.414 1.374-4.786 4.65z",
		clipRule: "evenodd"
	})
});
export default SvgArrowBack;
